<!-- eslint-disable vue/no-v-html -->
<template>
    <div id="header-taglines" class="flex flex-wrap gap-4 justify-center my-5">
        <NuxtLink
            v-for="link in links"
            :id="link.id"
            :key="link.to"
            :to="link.to"
            class="w-36 flex flex-col gap-2 md:gap-4 items-center text-sm text-center uppercase hover:no-underline hyphens-auto">
            <img :src="link.svg" class="size-8 md:size-12" alt="" />
            <div class="text-[#b7deff] max-w-40">{{ link.label }}</div>
        </NuxtLink>
    </div>
</template>
<script setup>
import whyAuthorizedSvg from "~/assets/tag-lines/why_authorized.svg";
import whatIsAuthorizedSvg from "~/assets/tag-lines/what_is_authorized.svg";
import buyersSvg from "~/assets/tag-lines/buyers.svg";
import engineersSvg from "~/assets/tag-lines/engineers.svg";
import distributorsSvg from "~/assets/tag-lines/distributors.svg";
import factorySvg from "~/assets/tag-lines/factory.svg";
import ecoSvg from "~/assets/tag-lines/eco.svg";

const { t } = useI18n();
const localePath = useLocalePath();

const links = [
    {
        to: localePath("/what-is-authorized"),
        svg: whatIsAuthorizedSvg,
        label: t("Home.WhatIsAuthorized"),
        id: "article-link-what-is-authorized",
    },
    {
        to: localePath("/why-buy-authorized-electronic-components"),
        svg: whyAuthorizedSvg,
        label: t("Home.WhyAuthorizedMatters"),
        id: "article-link-why-buy-authorized",
    },
    { to: localePath("/features-buyers"), svg: buyersSvg, label: t("Home.Buyers"), id: "article-link-features-buyers" },
    {
        to: localePath("/features-engineers"),
        svg: engineersSvg,
        label: t("Home.Engineers"),
        id: "article-link-features-engineers",
    },
    {
        to: localePath("/features-distributors"),
        svg: distributorsSvg,
        label: t("Global.Distributors"),
        id: "article-link-features-distributors",
    },
    {
        to: localePath("/features-component-manufacturers"),
        svg: factorySvg,
        label: t("Home.ComponentManufacturers"),
        id: "article-link-features-component-manufacturers",
    },
    {
        to: localePath("/product-carbon-footprint-values"),
        svg: ecoSvg,
        label: t("Home.CO2Emissions"),
        id: "article-link-product-carbon-footprint-values",
    },
];
</script>
